import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import './index.css';
import reportWebVitals from "./reportWebVitals";
import "./styles/app.scss";

//Remove all console
if (process.env.NODE_ENV !== "development") {
    console.log = () => { };
    //   console.warn = () => {};
    //   console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
